import { jwtDecode } from 'jwt-decode'
import { ApiSignUp } from '../apis/api.signup'

export const useToken = () => {
    const token = ApiSignUp.defaults.headers.common.Authorization?.toString().replace('Bearer ', '')
    let payload: TokenPayload | null = null
    try {
        if (token) payload = decodeToken<TokenPayload>(token)
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
    }
    return { ...payload, token, isLogged: !!payload?._id }
}

export const decodeToken = <T>(token: string) => {
    try {
        return jwtDecode<T>(token)
    } catch (_error) {
        return null
    }
}

export type TokenDTO = Partial<ReturnType<typeof useToken>>

interface TokenPayload {
    _id: string
    _profileId: string
    _classId: string
    _hqId: string
    role: string
    _teamId: string
    iat: number
    exp: number
}
